
import { Component, Vue, Prop } from 'vue-property-decorator';
import Installing from '@/components/Installing.vue';
import { UserPackageModel } from '@/models/user_package';
import { BillingPackageList } from '@/collections/billing_packages';
import { StoreModel } from '@/models/store';
import { isEmbedded, redirectExternal } from '@/utils/shopifyBridge';
import { EventHandler } from '@/modules/events';
import { EventBus } from '@/main';
import { BillingPackageModel } from '@/models/billing_package';
import { fetchDiscount } from '@/services/discountService';

@Component({
  components: {
    Installing,
  },
})
export default class SubscriptionConfirm extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: null })
  public app!: any;
  public billingPackages: BillingPackageList = new BillingPackageList();
  public selectedBillingPackage: BillingPackageModel = new BillingPackageModel();
  public userPackage: UserPackageModel = new UserPackageModel();
  public selectedBillingPackageId: string = '';

  public async created() {
    let interval = this.$route.query.interval || 'EVERY_30_DAYS';
    let isYearly: boolean = false;
    if (interval === 'ANNUAL') {
      isYearly = true;
    }

    if (this.$route.query.billing_package_id) {
      this.selectedBillingPackageId = this.$route.query.billing_package_id + '';
    }

    await this.billingPackages.fetch();
    await this.selectBillingPackage();

    let trialDays: number | undefined;
    let discountRate = 0;

    if (this.$route.query.discount) {
      const discountCode = this.$route.query.discount + '';
      this.userPackage.discountCode = discountCode;
      const discountInfo = await fetchDiscount(discountCode);
      if (discountInfo) {
        trialDays = discountInfo.package_config?.trialDays;
        discountRate = discountInfo.rate || 0;
      }
    }

    this.userPackage.billingPackageId = this.selectedBillingPackage.id;
    let returnUrl = `${process.env.VUE_APP_SUBSCRIPTION_RETURN_URL}`;
    if (isEmbedded()) {
      returnUrl = `https://admin.shopify.com/store/${this.store.shopName.split('.')[0]}/apps/${process.env.VUE_APP_NAME}/subscription/confirm`;
    }

    const confirmationUrl = await this.userPackage.create(
      trialDays,
      discountRate,
      returnUrl,
      [],
      isYearly,
    );

    if (this.userPackage.status === 'CONFIRMING' && confirmationUrl) {
      let eventName = 'CONFIRMING_PAID_PACKAGE';
      if (discountRate > 0) {
        eventName = `CONFIRMING_PAID_PACKAGE_AFTER_OFFER_${discountRate}`;
      }
      try {
        const eventHandler = new EventHandler({
          store: this.store,
        });
        eventHandler.track(eventName, {
          billing_package_id: this.userPackage.billingPackageId,
          version: this.userPackage.billingPackageVersion,
        });
        this.store.sendEvent(eventName, {
          billing_package_id: this.userPackage.billingPackageId,
          version: this.userPackage.billingPackageVersion,
        });
      } catch (e) {
        // ignore this
      }
      redirectExternal(confirmationUrl);
    }
  }

  public selectBillingPackage() {
    const assistyPlan = this.store.assistyPlan;
    if (this.selectedBillingPackageId) {
      for (const item of this.billingPackages.items) {
        if (assistyPlan === item.shopifyPlanName && item.id === Number(this.selectedBillingPackageId)) {
          this.selectedBillingPackage = item;
          return;
        }
      }
    }
    for (const item of this.billingPackages.items) {
      if (assistyPlan === item.shopifyPlanName) {
        this.selectedBillingPackage = item;
        break;
      }
    }
    for (const item of this.billingPackages.items) {
      if (item.id === this.userPackage.billingPackageId) {
        if (item.price > this.selectedBillingPackage.price) {
          this.selectedBillingPackage = item;
        }
      }
    }
  }
}
